import React, {FC} from "react";
import {garageConfig} from "../../../enums/GarageType";
import {Locale} from "../../../locales/Locale";

interface IRenderGarageType {
    value: string;
}

export const RenderGarageType: FC<IRenderGarageType> = ({ value }) => {
    const types = value.split(",").map((t) => t.trim());

    const renderedTypes = types
        .map((type) => {
            const config = garageConfig.find((item) => item.name === type);
            return config ? <Locale key={type} localeId={config.locaId} /> : null;
        })
        .filter(Boolean);

    if (!renderedTypes.length) {
        return <>N/A</>;
    }

    return (
        <>
            {renderedTypes.map((element, index) => (
                <React.Fragment key={index}>
                    {index > 0 && ", "}
                    {element}
                </React.Fragment>
            ))}
        </>
    );
};
